// extracted by mini-css-extract-plugin
module.exports = {"page_404":"patherror_page_404__3J6cS","page_404_image":"patherror_page_404_image__3Krta","link_404":"patherror_link_404__3UIIu"};